import React from "react";
import { getText, getImage } from '../shared/customization';

export default function About() {
  return (
    <div
      className="w-full  min-h-[60vh] "
      style={{
        background: `url(${getImage('Banner5')}) no-repeat center`,
        backgroundSize: "cover",
      }}
    >
      <div
        className="w-full  min-h-[60vh] px-10"
        style={{ backgroundColor: "rgba(0, 15, 45, 0.3)" }}
      >
        <div className="w-full pt-16 pb-16">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-20 max-w-[1200px] mx-auto">
            <h1 className="text-6xl text-center text-white font-semibold">
              {getText('About.Title')}
            </h1>
            <div></div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-20 max-w-[1200px] mx-auto">
          <div>
            <h2 className="text-2xl text-white text-center font-semibold pb-2">
              {getText('About.Subtitle1')}
            </h2>
            <p className="text-lg text-white text-justify leading-8">
              {getText('About.Text1')}
            </p>
          </div>
          <div>
            <h2 className="text-2xl text-white text-center font-semibold pb-2">
              {getText('About.Subtitle2')}
            </h2>
            <p className="text-lg text-white text-justify leading-8">
              {getText('About.Text2')}
            </p>
          </div>
        </div>
        <div>
          <p className="pt-10 text-lg text-white text-center">
            {getText('About.Contact')}
          </p>
        </div>
      </div>
    </div>
  );
}
